import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import Title from '../../partials/title';
import { Link } from 'react-router';

// August 6th: Refactored for responsiveness
const Rankings = ({ className }) => {
    return (
        <div className={`${className}`} style={{ position: 'relative', minHeight: 700 }} id="rankings-home">

            <div className="d-flex row-into-column w-100 h-100 rankings-gender-background" style={{ position: 'absolute' }}>
                <div className="w-100" style={{ background: `url("/images/backgrounds/soccer-boy-dark.jpg") no-repeat center center`, backgroundSize: 'cover' }} />
                <div className="w-100" style={{ background: `url("/images/backgrounds/soccer-girl-dark.jpg") no-repeat center center`, backgroundSize: 'cover' }} />
            </div>

            <ScrollAnimation animateIn="fadeIn" animateOnce={true} className="d-flex flex-row justify-content-center" style={{ position: 'absolute', top: 20, bottom: 20, left: 20, right: 20, border: '1px solid #e5e5e5' }}>
                <span className="align-self-center hero-text anton">RANKINGS</span>
            </ScrollAnimation>

            <Link to='/rankings/b'>
                <div className="d-flex flex-row justify-content-center left pointer" >
                    <ScrollAnimation animateIn="fadeInLeft" animateOnce={true} className="align-self-end" style={{ marginBottom: '5em' }}>
                        <Title text="VIEW BOYS RANKINGS" className="white" />
                    </ScrollAnimation>
                </div>
            </Link>

            <Link to='/rankings/g'>
                <div className="d-flex flex-row justify-content-center right pointer" >
                    <ScrollAnimation animateIn="fadeInRight" animateOnce={true} className="align-self-end" style={{ marginBottom: '5em' }}>
                        <Title text="VIEW GIRLS RANKINGS" className="white" />
                    </ScrollAnimation>
                </div>
            </Link>
        </div>
    );
}

export default Rankings;



// WEBPACK FOOTER //
// ./src/components/rankings/partials/home.js